"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("homeAad", function () {
  return {
    restrict: "E",
    replace: true,
    template: require("./home-aad.html"),
    controller: function controller($scope, $http, aadService) {
      var loadResumeInfoClient = function loadResumeInfoClient() {
        $http.get('/rest/home/resume-information-client').then(function (response) {
          $scope.resumeInformationClient = response.data;
        });
      };
      loadResumeInfoClient();
      $scope.editAad = function (aadId) {
        aadService.openEditionPopin($scope, aadId).then(function () {
          loadResumeInfoClient();
        });
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/home/aad/home-aad.js
// module id = 2784
// module chunks = 13